import Button from './classes/buttons';
import IsInView from './classes/isInView';
import {creator} from './lib/utilities';

export const initCommonModules = () => {
  window.fkCommons.Button = creator('[role=button]', Button);
  window.fkCommons.Button = creator('.btn', Button);
  window.fkCommons.Button = creator('.js-checkbox-toggle', Button);
  window.fkCommons.IsInView = creator('[data-common="IsInView"]', IsInView);


  Object.entries(window.fkCommons).forEach(([key, value]) => {
    if (value.length > 0) {
      if (window.fkCommons[key].length > 0) {
        window.fkCommons[key].forEach((item) => {
          item.mount();
        });
      }
    }
  });
};
